import { css } from '@repo/pandacss/styled-system/css';
import Image from 'next/image';

const containerClass = css({ display: 'flex', alignItems: 'center', flexDirection: 'column' });
const headingClass = css({ fontSize: 'xxl', fontWeight: '[350]', pb: '4', textAlign: 'center' });
const bodyClass = css({ fontWeight: '[325]', textAlign: 'center', sm: { width: '[600px]' } });

export const EmptyState = () => (
  <div className={containerClass}>
    <Image
      src="https://www.nerdwallet.com/cdn/banking/cd-rates/magnifying_glass.svg"
      alt="Empty result"
      width={116}
      height={114}
    />
    <p className={headingClass}>Didn't find what you're looking for?</p>
    <p className={bodyClass}>
      We couldn't find any results that match your filters. Please try adjusting your criteria and
      search again.
    </p>
  </div>
);
